export const fa: Record<string, string> = {
  // ---------- Tabs ----------
  "tabs.dashboard": "داشبورد",
  "tabs.charts": "نمودارها",
  "tabs.records": "ثبت‌ها",
  "tabs.shifts": "شیفت‌ها",
  "tabs.people": "افراد",
  "tabs.settings": "تنظیمات",
  "tabs.report": "گزارش",
  "tabs.emergency": "اضطراری",
  "tabs.my_records": "ثبت‌های من",
  "tabs.turbines": "توربین‌ها",
  "tabs.automatika": "اتوماسیون",
  "tabs.power_analyzer": "Power Analyzer",
  "tabs.scada": "SCADA",
  "tabs.scada_v2": "اتوماسیون v2",
  "tabs.combined": "نمای کلی",
  "tabs.incidents": "حوادث",
  "incidents.pick": "رویداد",
  "incidents.trip": "قطع",
  "incidents.onset": "شروع خروج از محدوده",
  "incidents.window": "بازه داده",
  "incidents.kpi_umax": "حداکثر U",
  "incidents.kpi_kwmax": "حداکثر P",
  "incidents.kpi_qmax": "حداکثر Q",
  "incidents.kpi_hz": "f کمینه–بیشینه",
  "incidents.kpi_oob": "خارج از محدوده",
  "incidents.kpi_alarms": "هشدارها",
  "incidents.sec": "ثانیه",
  "incidents.chart_v": "ولتاژ خطوط RS / ST / RT",
  "incidents.chart_p": "توان و فرکانس",
  "incidents.chart_pos": "سرعت توربین و پره راهنما",
  "incidents.kpi_speed": "حداکثر سرعت",
  "incidents.speed_label": "n — سرعت توربین، %",
  "incidents.pos_label": "GV — پره راهنما، %",
  "incidents.metrics_n": "شاخص",
  "incidents.diff_label": "حفاظت دیفرانسیل (87H)",
  "incidents.q1_label": "کلید Q1 (سلول H01)",
  "incidents.fired": "فعال شد در",
  "incidents.pre_label": "انحراف‌ها پیش از قطع",
  "incidents.grp_power": "توان",
  "incidents.grp_voltage": "ولتاژ",
  "incidents.grp_current": "جریان",
  "incidents.grp_temperature": "دماها",
  "incidents.grp_pressure": "فشار",
  "incidents.grp_level": "سطوح",
  "incidents.grp_control": "کنترل",
  "incidents.grp_counter": "شمارنده‌ها",
  "incidents.marker_trip": "قطع",
  "incidents.marker_onset": "خروج از محدوده",
  "incidents.alarms_title": "ژورنال هشدارها (EN + RU)",
  "incidents.col_ru": "هشدار (روسی)",
  "incidents.table_title": "داده‌های ثانیه‌ای",
  "incidents.table_note": "همه شاخص‌های تله‌متری. ◆ — ثانیه قطع؛ قرمز — ولتاژ بالاتر از محدوده، نارنجی — سرعت‌گرفتن توربین. جدول به‌صورت افقی اسکرول می‌شود؛ ستون زمان ثابت است.",
  "combined.title": "نمای کلی — همه داده‌ها",
  "combined.max_kw": "توان اوج",
  "combined.total_energy": "کل انرژی",
  "combined.total_run": "زمان کار (کل)",
  "combined.by_source": "بر اساس منبع داده",
  "combined.sharp_title": "پرش‌های ناگهانی ولتاژ — بازه‌های ۵ دقیقه‌ای برتر",
  "combined.sharp_hint": "بر اساس تعداد پرش‌های ثانیه‌به‌ثانیه (≥{kv} kV). ضربه → ثانیه‌ای",
  "combined.prolonged_title": "انحراف‌های طولانی — بازه‌های ۵ دقیقه‌ای برتر",
  "combined.prolonged_hint": "بر اساس طولانی‌ترین سری پیوسته خارج از کریدور {lo}–{hi} kV (از {s} ثانیه). ضربه → ثانیه‌ای",
  "combined.detail_hint": "بازه ±۱۰ ثانیه · {sharp} ثانیه پرش · {oob} ثانیه خارج از محدوده",
  "combined.legend_sharp": "ثانیه‌های پرش (|Δ|≥1 kV)",
  "combined.legend_band": "محدوده مجاز",
  "combined.col_time": "زمان",
  "combined.sub_overview": "نمای کلی",
  "combined.sub_vband": "کریدور {lo}–{hi}",
  "vband.period": "بازه",
  "vband.all": "کل زمان",
  "vband.days": "روز",
  "vband.hours": "ساعت",
  "vband.data": "داده",
  "vband.bucket": "بازه تجمیع",
  "vband.in_band": "داخل محدوده",
  "vband.above": "بالاتر از",
  "vband.below": "پایین‌تر از",
  "vband.min_unit": "دقیقه",
  "vband.chart_title": "R / S / T داخل کریدور {lo}–{hi} کیلوولت",
  "vband.chart_hint": "ناحیه سبز = محدوده مجاز {lo}–{hi} کیلوولت. نقاط رنگی خروج از محدوده‌اند: قرمز بالای {hi}، آبی زیر {lo} کیلوولت. فقط دقایق زیر بار محاسبه می‌شود.",
  "vband.by_phase": "بر اساس فاز",
  "vband.phase": "فاز",
  "vband.excursions": "خروج‌ها از محدوده",
  "vband.peak": "اوج، kV",
  "vband.dur": "مدت",
  "vband.dir": "جهت",
  "vband.exc_hint": "بر اساس بزرگی انحراف مرتب شده. 📈 — تله‌متری ثانیه‌ای آن لحظه.",
  "vband.no_dev": "خروجی از محدوده نیست",
  "combined.sub_drill": "جدول",
  "combined.sub_alarms": "هشدارها",
  "combined.event_hint": "لحظه هشدار {at} (±۴۵ ثانیه). ◆ ثانیه رویداد؛ نقاط قرمز پرش‌ها",
  "combined.no_telemetry": "برای این لحظه تله‌متری نیست",
  "combined.unit_stopped": "واحد در این لحظه متوقف بوده (ولتاژ و توان = ۰)",
  "combined.zero_legend": "🟡 زرد — واحد خاموش بوده (فقط صفر)",
  "combined.moment": "لحظه هشدار",
  "combined.drill_source": "منبع",
  "alarms.total": "کل هشدارها",
  "alarms.active_now": "فعال اکنون",
  "alarms.not_acked": "تأیید نشده",
  "alarms.records": "رکورد",
  "alarms.by_unit": "بر اساس واحد",
  "alarms.by_category": "بر اساس دسته",
  "alarms.period": "بازه",
  "alarms.filter_unit": "واحد",
  "alarms.all": "همه",
  "alarms.active_only": "فقط فعال",
  "alarms.leaderboard": "پرتکرارترین هشدارها",
  "alarms.leaderboard_hint": "بر اساس تعداد وقوع. ضربه → همه رخدادها",
  "alarms.active_short": "فعال",
  "alarms.last": "آخرین",
  "alarms.occurrences": "وقوع",
  "alarms.all_periods": "همه بازه‌ها",
  "alarms.of_total": "از {n}",
  "alarms.none_with_data": "هیچ رخدادی با تله‌متری نیست (واحد خاموش بوده یا داده‌ای نیست)",
  "alarms.cat.TRIP": "قطع حفاظتی",
  "alarms.cat.VOLTAGE_MISS": "افت ولتاژ",
  "alarms.cat.COMM_LOST": "قطع ارتباط",
  "alarms.cat.LUBRICATION": "روانکاری",
  "alarms.cat.POWER_SUPPLY": "منبع تغذیه",
  "alarms.cat.AUTH": "احراز هویت",
  "alarms.cat.SYSTEM": "سیستم",
  "alarms.cat.OTHER": "سایر",
  "minmax.min": "کمینه",
  "minmax.max": "بیشینه",
  "alarms.show_telemetry": "تله‌متری",
  "alarms.filter_cat": "دسته",
  "alarms.log_title": "ثبت هشدارها",
  "alarms.col_unit": "واحد",
  "alarms.col_msg": "پیام",
  "alarms.load_more": "بیشتر",
  "tabs.users": "کاربران",
  "users.title": "کاربران",
  "users.create_invite": "➕ ساخت لینک دعوت",
  "users.invite_hint": "لینک یک‌بارمصرف، اعتبار ۷ روز. آن را برای فرد بفرستید — با باز کردن، دسترسی فقط‌خواندنی می‌گیرد.",
  "users.link_label": "لینک دعوت (برای کپی بزنید):",
  "users.copy": "کپی",
  "users.copied": "کپی شد",
  "users.none": "هنوز کاربر دعوت‌شده‌ای نیست.",
  "users.col_user": "کاربر",
  "users.col_status": "وضعیت",
  "users.col_joined": "تاریخ",
  "users.col_tabs": "بخش‌ها",
  "users.invite_tabs": "بخش‌هایی که کاربر می‌بیند:",
  "users.invite_name": "نام (تا بدانید چه کسی است):",
  "users.name_placeholder": "مثلاً ایوان — شیفت ۲",
  "users.delete": "حذف",
  "users.delete_confirm": "{name} حذف شود؟ دسترسی خواندن قطع می‌شود و ربات دیگر او را پردازش نمی‌کند.",
  "users.active": "فعال",
  "users.inactive": "غیرفعال",
  "users.deactivate": "غیرفعال‌کردن",
  "users.activate": "فعال‌کردن",

  // ---------- Автоматика (SCADA) ----------
  "auto.sub_overview": "نمای کلی",
  "auto.sub_charts": "نمودارها",
  "auto.sub_anomalies": "انحرافات",
  "auto.sub_jumps": "جهش‌ها",
  "auto.sub_minmax": "کمینه/بیشینه",
  "auto.oob_n": "{n} خارج از محدوده",
  "auto.dev_by_line": "انحراف‌ها بر اساس خط",
  "auto.dev_short": "انحراف",
  "auto.dev_day": "روز",
  "auto.dev_total": "مجموع دوره",
  "auto.dev_band": "محدوده",
  "auto.v_line": "ولتاژ خطی، kV",
  "auto.v_phase": "ولتاژ فاز، kV",
  "minmax.bucket": "بازه",
  "minmax.sec": "ثانیه‌ای",
  "minmax.time": "زمان",
  "minmax.hint": "برای ریزتر شدن روی سطر بزنید (ساعت ← ۵ دقیقه ← دقیقه). قرمز = خارج از {lo}–{hi} kV.",
  "minmax.hint_leaf": "کمینه/بیشینه دقیقه‌ای. قرمز = خارج از {lo}–{hi} kV.",
  "jumps.hint": "تغییرات ناگهانی بین نمونه‌های مجاور (پرش تند بالا/پایین). {n} مورد یافت شد.",
  "jumps.none": "جهش تندی یافت نشد.",
  "auto.sub_data": "داده‌ها",
  "auto.all": "همه",
  "auto.last_3d": "۳ روز اخیر",
  "auto.last_1d": "روز آخر",
  "auto.data_range": "داده‌ها",
  "auto.timeframe": "بازه زمانی",
  "auto.tf_all": "همه داده‌ها",
  "auto.tf_7d": "۷ روز اخیر",
  "auto.tf_3d": "۳ روز اخیر",
  "auto.tf_1d": "۲۴ ساعت اخیر",
  "auto.tf_12h": "۱۲ ساعت اخیر",
  "auto.tf_6h": "۶ ساعت اخیر",
  "auto.tf_1h": "یک ساعت اخیر",
  "auto.tf_custom": "بازه دلخواه…",
  "auto.hide_zeros": "پنهان‌کردن صفرها",
  "auto.truncated": "۵۰۰ مورد برتر",
  "auto.tap_for_details": "برای جزئیات کامل بزنید",
  "auto.snapshot_title": "📸 وضعیت در این لحظه",
  "auto.resolution": "تفکیک‌پذیری",
  "auto.res_auto": "خودکار",
  "auto.res_raw": "ثانیه‌ای",
  "auto.reset_zoom": "بازنشانی زوم",
  "auto.deviations_n": "{n} علامت‌خورده",
  "auto.drill_hint": "برای بزرگ‌نمایی روی هر نقطه بزنید؛ یا نوار پایین را بکشید و «زوم به محدوده» را بزنید. نقاط قرمز در آن بازه انحراف داشتند.",
  "auto.zoom_to_sel": "زوم به محدوده",
  "auto.back": "← بازگشت",
  "charts.overlay": "هم‌پوشانی",
  "charts.overlay_none": "هیچ",
  "charts.right_axis": "محور راست",
  "auto.filter_metric": "فیلتر بر اساس شاخص",
  "auto.all_metrics": "همه شاخص‌ها",
  "auto.minutes": "دقیقه",
  "auto.min_short": "دق",
  "auto.bucket": "بازه",
  "auto.kpi_running": "در حال کار",
  "auto.kpi_peak_power": "اوج توان",
  "auto.kpi_avg": "میانگین",
  "auto.kpi_span": "دوره",
  "auto.kpi_energy": "انرژی تولیدی",
  "auto.kwh": "کیلووات‌ساعت",
  "auto.mwh": "مگاوات‌ساعت",
  "auto.col_metric": "شاخص",
  "auto.no_anomalies": "انحراف قابل‌توجهی در این دوره نیست.",
  "auto.anomalies_hint": "{n} رویداد (≥ {floor}٪ از نرمال، فراتر از ±۲σ در دوره‌های کارکرد).",
  "auto.off_normal": "از نرمال",
  "auto.normal": "نرمال",
  "auto.when": "زمان",
  "auto.upload_title": "بارگذاری CSV ایستگاه",
  "auto.upload_hint": "خروجی SCADA (جداشده با فاصله، ‎.csv یا ‎.gz). فایل بزرگ را ‎.gz بفرستید. در پس‌زمینه پردازش می‌شود؛ جدا از ثبت‌های دستی.",
  "auto.uploading": "در حال بارگذاری…",
  "auto.upload_started": "فایل دریافت شد — پردازش در پس‌زمینه…",
  "auto.upload_done": "انجام شد — {rows} ردیف وارد شد.",
  "auto.upload_error": "خطای پردازش — قالب فایل را بررسی کنید.",
  "auto.export_xlsx": "📥 دانلود اکسل (دوره)",
  "auto.export_hint": "ردیف‌های خام ثانیه‌ای برای دوره انتخابی، ستون‌های اصلی، هر روز یک برگه.",
  "auto.imports_title": "بارگذاری‌ها",
  "auto.col_file": "فایل",
  "auto.col_status": "وضعیت",
  "auto.col_rows": "ردیف",
  "auto.col_period": "دوره",

  // ---------- Turbines ----------
  "turbines.title": "🏭 توربین‌ها",
  "turbines.empty_for_station": "ایستگاه شما هنوز توربین ندارد. به مدیر مراجعه کنید.",
  "turbines.none_for_station": "توربینی نیست.",
  "turbines.active": "فعال",
  "turbines.inactive": "غیرفعال",
  "turbines.status_running": "در حال کار",
  "turbines.status_stopped": "متوقف",
  "turbines.status_off": "خاموش",
  "turbines.activate": "فعال‌سازی",
  "turbines.deactivate": "غیرفعال‌سازی",
  "turbines.state_running": "در حال کار",
  "turbines.state_stopped": "متوقف",
  "turbines.state_off": "خارج از سرویس",
  "turbines.start_btn": "شروع",
  "turbines.start_sub": "ثبت شروع با KV فعلی",
  "turbines.start_title": "شروع {name}",
  "turbines.confirm_start": "شروع",
  "turbines.stop_btn": "توقف",
  "turbines.stop_sub": "ثبت توقف با KW، زمان و علت",
  "turbines.stop_title": "توقف {name}",
  "turbines.confirm_stop": "توقف",
  "turbines.stop_time": "زمان توقف",
  "turbines.stop_reason": "علت",
  "turbines.stop_reason_placeholder": "چرا توربین متوقف شد؟",
  "turbines.recent_events": "تاریخچه رویدادها",
  "turbines.evt_start": "شروع",
  "turbines.evt_stop": "توقف",
  "turbines.tab_list": "توربین‌ها",
  "turbines.tab_history": "تاریخچه",
  "turbines.no_events": "هنوز رویدادی نیست.",
  "turbines.fill_btn": "تکمیل گزارش",
  "turbines.fill_sub": "ثبت مقادیر برای این توربین",
  "turbines.fill_sub_offline": "توربین متوقف است — ورودی نارنجی می‌شود",

  // ---------- Common ----------
  "common.loading": "در حال بارگذاری…",
  "common.cancel": "لغو",
  "common.save": "ذخیره",
  "common.delete": "حذف",
  "common.edit": "ویرایش",
  "common.create": "ایجاد",
  "common.close": "بستن",
  "common.retry": "تلاش مجدد",
  "common.back": "بازگشت",
  "common.add": "افزودن",
  "common.submit": "ارسال",
  "common.no_changes": "تغییری نیست",
  "common.saved": "ذخیره شد",
  "common.copied": "کپی شد",
  "common.copy_link": "📋 کپی لینک",
  "common.no_data": "برای بازه انتخاب‌شده داده‌ای وجود ندارد.",
  "common.empty": "هنوز چیزی نیست.",
  "common.error_generic": "خطایی رخ داد. دوباره تلاش کنید.",
  "common.no_connection": "اتصال به سرور برقرار نیست",
  "common.timeout": "سرور پاسخ نمی‌دهد — دوباره تلاش کنید",

  // ---------- Access / desktop hint ----------
  "access.locked_title": "دسترسی ندارید",
  "access.locked_hint": "تنها کاربران ثبت‌شده می‌توانند این اپ را باز کنند. از مدیر لینک دعوت بخواهید.",
  "desktop_hint.title": "در تلگرام باز کنید",
  "desktop_hint.body": "این یک Mini App تلگرام است. بات را در تلگرام باز کنید و 📱 کنار فیلد ورودی را بزنید.",

  // ---------- Periods ----------
  "period.today": "امروز",
  "period.yest": "دیروز",
  "period.7d": "۷ روز",
  "period.30d": "۳۰ روز",
  "period.all": "همه",

  // ---------- Status / types ----------
  "status.completed": "✅",
  "status.miss_short": "از دست",
  "type.plan": "برنامه",
  "type.emergency": "🚨 اضطراری",
  "type.missed": "🚫 از دست رفته",
  "type.late": "🟨 با تأخیر",
  "type.offline": "🟠 آفلاین",
  "filter.all": "همه",

  // ---------- Charts ----------
  "charts.title": "📈 نمودارها",
  "charts.select_chart": "انتخاب نمودار",
  "charts.turbine": "توربین",
  "charts.period": "بازه",
  "charts.kw_kv_label": "نوسانات KW و KV",
  "charts.kw_kv_title": "KW و KV در طول زمان",
  "charts.kw_kv_hint": "دو خط: KW (محور چپ) و KV (محور راست). جهش‌های ولتاژ به‌راحتی دیده می‌شوند.",
  "charts.kw_kv_offline_title": "روند KW و KV (توربین متوقف)",
  "charts.kw_kv_offline_hint": "فقط ثبت‌هایی که هنگام توقف توربین انجام شده‌اند. KW (نارنجی، محور چپ) و KV (بنفش، محور راست).",

  "charts.compare_label": "مقایسه توربین‌ها (KW)",
  "charts.compare_hint": "منحنی توان همه توربین‌ها در یک نمودار. توزیع نامتعادل بار و توربین‌های متوقف به‌راحتی دیده می‌شود.",

  "charts.timeline_label": "خط زمانی کار/توقف",
  "charts.timeline_hint": "نوارهای افقی برای هر توربین: سبز = در حال کار، قرمز = متوقف. کل زمان توقف در بازه روی یک صفحه.",
  "charts.timeline_running": "در حال کار",
  "charts.timeline_stopped": "متوقف",

  "charts.temperatures_label": "دماهای BT",
  "charts.temperatures_hint": "سنسورهای دما BT 371, BT 372, BT 331, BT 332 در یک نمودار. جهش هر منحنی نشانه ریسک گرم‌شدگی است.",

  "charts.frequency_label": "فرکانس (Hz)",
  "charts.frequency_hint": "فرکانس تولید با خطوط مرجع 49.5 و 50.5. انحراف بیش از 0.5 Hz یعنی مشکل در شبکه.",
  "charts.freq_low": "49.5 Hz (پایین)",
  "charts.freq_high": "50.5 Hz (بالا)",

  "charts.stop_reasons_label": "علل توقف",
  "charts.stop_reasons_hint": "توزیع دلایل از فرم Stop توربین. نشان می‌دهد چه مشکلاتی بیشتر تکرار می‌شوند.",
  "charts.stop_reasons_empty": "در این بازه هیچ توقفی ثبت نشده.",
  "charts.reason_unknown": "نامشخص",

  "charts.kw_histogram_label": "توزیع KW (هیستوگرام)",
  "charts.kw_histogram_hint": "چند ثبت در هر بازه ۲۰۰ KW قرار گرفته. حالت کاری غالب توربین را نشان می‌دهد.",

  "charts.cos_kvar_label": "cos φ و Kvar",
  "charts.cos_kvar_hint": "ضریب توان cos φ (محور چپ، 0..1) و توان راکتیو Kvar (محور راست). افت cos φ یعنی مشکل کیفیت تولید.",

  "charts.pressure_label": "فشارها (BP 371، Bar، Pipe pressure)",
  "charts.pressure_hint": "همه فشارها در یک نمودار. جهش‌های شدید نشانه شرایط اضطراری در مدار هیدرولیک یا بخار است.",

  "charts.scatter_label": "KW vs KV (پراکندگی)",
  "charts.scatter_hint": "نمودار پراکندگی، هر نقطه = یک ثبت. همبستگی توان و ولتاژ را نشان می‌دهد؛ نقاط پرت برجسته‌اند.",

  "analysis.title": "تحلیل",
  "analysis.no_data": "داده کافی برای تحلیل در این بازه وجود ندارد.",
  "analysis.records": "تعداد ثبت‌ها: {n}.",

  "analysis.kv_ok": "ولتاژ در محدوده نرمال (KV {min}–{max}، هدف ۱۷–۲۲).",
  "analysis.kv_out": "ولتاژ خارج از محدوده نرمال (KV {min}–{max}، انتظار ۱۷–۲۲). وضعیت شبکه را بررسی کنید.",
  "analysis.kw_stable": "توان خروجی پایدار است، میانگین {avg} KW.",
  "analysis.kw_unstable": "توان ناپایدار: پراکندگی {cv}% از میانگین {avg} KW. بار را بررسی کنید.",

  "analysis.turbine_idle": "{name}: در این بازه داده‌ای ثبت نشده — توربین متوقف بود.",
  "analysis.turbine_avg": "{name}: میانگین توان {avg} KW.",
  "analysis.compare_balanced": "بار به‌طور یکنواخت بین توربین‌ها توزیع شده.",
  "analysis.compare_imbalance": "عدم تعادل بار: {hi} ({hiAvg} KW) به‌مراتب بیشتر از {lo} ({loAvg} KW).",

  "analysis.timeline_overall": "زمان کار جمعی همه توربین‌ها: {uptime}%. کل توقف‌ها: {stops}.",
  "analysis.timeline_turbine": "{name}: {uptime}% زمان در حال کار، توقف {downtime}.",

  "analysis.temp_ok": "دماها نرمال، حداکثر {max}°C (آستانه ۷۰°C).",
  "analysis.temp_warn": "دما بالا، حداکثر {max}°C. نرمال تا ۷۰°C، بحرانی بالای ۸۵°C — سنسورها را پایش کنید.",
  "analysis.temp_critical": "گرم‌شدگی! حداکثر {max}°C در سنسورها: {sensors}. نیاز به توجه دارد.",
  "analysis.temp_avg": "میانگین دما: {avg}°C.",

  "analysis.freq_ok": "فرکانس پایدار: {min}–{max} Hz، در محدوده نرمال ۴۹٫۵–۵۰٫۵.",
  "analysis.freq_bad": "فرکانس از محدوده خارج شده: زیر ۴۹٫۵ — {low} نقطه، بالای ۵۰٫۵ — {high} (از {total}).",
  "analysis.freq_avg": "میانگین فرکانس: {avg} Hz.",

  "analysis.stop_none": "در این بازه هیچ توقفی نبوده — عالی.",
  "analysis.stop_total": "کل توقف‌ها: {n}.",
  "analysis.stop_top": "شایع‌ترین علت: «{name}» ({pct}%).",
  "analysis.stop_dominant": "یک علت غالب است: «{name}» ({pct}% همه توقف‌ها). بررسی منبع توصیه می‌شود.",
  "analysis.stop_variety": "تنوع علل: {n} دسته متفاوت.",

  "analysis.hist_top": "بیشترین فراوانی توان در بازه {range} KW ({pct}%).",
  "analysis.hist_low": "{pct}% ثبت‌ها با توان پایین — کم‌باری مکرر.",
  "analysis.hist_normal": "{pct}% زمان در بار نرمال.",
  "analysis.hist_avg": "میانگین توان: {avg} KW.",

  "analysis.cos_ok": "cos φ نرمال (میانگین {avg}). کیفیت تولید بالا.",
  "analysis.cos_warn": "cos φ کاهش یافته (میانگین {avg}). نرمال ≥۰٫۹۵، جبران توان راکتیو توصیه می‌شود.",
  "analysis.cos_bad": "cos φ پایین (میانگین {avg}). تلفات قابل‌توجه — کم‌باری یا بار راکتیو بزرگ.",
  "analysis.kvar_avg": "Kvar: میانگین {avg}، بازه {min}–{max}.",

  "analysis.pressure_field": "{name}: میانگین {avg}، بازه {min}–{max}.",

  "analysis.scatter_few": "نقاط برای تحلیل همبستگی کم است.",
  "analysis.scatter_points": "{n} نقطه روی نمودار.",
  "analysis.scatter_corr_pos": "همبستگی مثبت قوی بین KW و KV (r={r}). ولتاژ با افزایش توان بالا می‌رود.",
  "analysis.scatter_corr_neg": "همبستگی منفی قوی بین KW و KV (r={r}). ولتاژ با افزایش توان پایین می‌آید.",
  "analysis.scatter_corr_none": "همبستگی مشخصی بین KW و KV نیست (r={r}).",

  // ---------- Dashboard ----------
  "dashboard.title": "📊 داشبورد",
  "dashboard.kpi.completed": "تکمیل‌شده",
  "dashboard.kpi.completed_sub": "{pct}٪ از برنامه",
  "dashboard.kpi.total": "کل اسلات‌ها",
  "dashboard.kpi.missed": "🚫 از دست رفته",
  "dashboard.kpi.late": "🟨 با تأخیر",
  "dashboard.kpi.emergency": "🚨 اضطراری",
  "dashboard.kpi.avg_response": "میانگین پاسخ",
  "dashboard.kpi.avg_response_sub": "از اعلان تا شروع",
  "dashboard.kpi.avg_kw": "میانگین KW",
  "dashboard.kpi.avg_kv": "میانگین KV",
  "dashboard.kpi.min_max_sub": "حداقل / حداکثر در بازه",
  "dashboard.kpi.min": "حداقل",
  "dashboard.kpi.max": "حداکثر",
  "dashboard.turbines.downtime": "زمان توقف",
  "dashboard.turbines.last_reading": "آخرین ثبت",
  "dashboard.turbines.no_downtime": "بدون توقف",
  "dashboard.turbines.no_data": "بدون داده",
  "dashboard.turbines.just_now": "همین الان",
  "dashboard.turbines.ago": "پیش",
  "dashboard.turbines.unit_d": "روز",
  "dashboard.turbines.unit_h": "س",
  "dashboard.turbines.unit_min": "د",
  "dashboard.sparkline.title": "روند KW در ۲۴ ساعت",
  "dashboard.sparkline.hint": "تمام ثبت‌های آنلاین توان از هر دو توربین",
  "dashboard.distribution.title": "توزیع اسلات‌ها",
  "dashboard.distribution.on_time": "✅ به‌موقع",
  "dashboard.distribution.late": "🟨 با تأخیر",
  "dashboard.distribution.missed": "🚫 از دست رفته",
  "dashboard.distribution.pending": "⏳ در حال انجام",
  "dashboard.distribution.emergency": "🚨 اضطراری",
  "dashboard.by_day.title": "تکمیل بر اساس روز، ٪",
  "dashboard.by_day.tooltip": "{pct}٪ ({completed}/{total})",
  "dashboard.by_day.tooltip_label": "تکمیل",
  "dashboard.by_hour.title": "تکمیل بر اساس ساعت",
  "dashboard.by_hour.legend": "🟢 بالا · 🟡 متوسط · 🔴 پایین",
  "dashboard.by_hour.legend_count": "تعداد گزارش‌های ثبت‌شده در هر ساعت روز (در بازه انتخاب‌شده).",
  "dashboard.by_hour.no_data": "داده‌ای نیست",
  "dashboard.users.title": "رتبه‌بندی اپراتورها",
  "dashboard.users.col_name": "نام",
  "dashboard.users.col_avg": "میانگین پاسخ",
  "dashboard.users.bar_title": "میانگین زمان پاسخ، ثانیه",
  "dashboard.empty": "برای بازه انتخاب‌شده داده‌ای نیست. بازه دیگری انتخاب کنید یا منتظر تیک ساعت بعدی بمانید.",

  // ---------- Records (admin) ----------
  "records.title": "📋 ثبت‌ها",
  "records.from": "از",
  "records.to": "تا",
  "records.download_xlsx": "📥 دانلود اکسل",
  "records.xlsx_per_day": "هر روزِ بازه یک برگه جداگانه می‌شود (مطابق ودومست شاخص‌ها).",
  "records.custom_preview": "🛠 پیش‌نمایش سفارشی",
  "records.col_date": "تاریخ",
  "records.col_turbine": "توربین",

  "custom_preview.title": "🛠 پیش‌نمایش سفارشی",
  "custom_preview.period": "بازه",
  "custom_preview.turbine": "توربین",
  "custom_preview.type": "نوع ثبت",
  "custom_preview.fields": "انتخاب‌شده: {n} از {total}",
  "custom_preview.select_all": "همه را انتخاب کن",
  "custom_preview.clear": "پاک کردن",
  "custom_preview.build_btn": "ساخت جدول",
  "custom_preview.building": "در حال ساخت…",
  "custom_preview.rows_count": "مجموع ردیف‌ها: {n}",
  "custom_preview.sort_hint": "برای مرتب‌سازی کلیک کنید",
  "records.col_slot": "اسلات",
  "records.col_who": "کاربر",
  "records.col_type": "نوع",
  "records.col_status": "وضعیت",
  "records.detail.title": "ثبت #{id}",
  "records.detail.slot": "اسلات",
  "records.detail.responsible": "مسئول",
  "records.detail.started": "شروع",
  "records.detail.completed": "پایان",
  "records.detail.response": "پاسخ",
  "records.detail.fill": "زمان تکمیل",
  "records.detail.reason": "علت",
  "records.detail.seconds": "ث",

  // ---------- My records (responsible) ----------
  "my_records.title": "📋 ثبت‌های من",
  "my_records.download_xlsx": "📥 دانلود اکسل",

  // ---------- Shifts (admin) ----------
  "shifts.title": "📅 شیفت‌ها",
  "shifts.choose_user": "یک مسئول انتخاب کنید",
  "shifts.fill_range": "📐 پر کردن بازه",
  "shifts.active_count": "شیفت‌های فعال ({n})",
  "shifts.empty": "شیفتی وجود ندارد. در تقویم روی روزی بزنید.",
  "shifts.range.title": "📐 پر کردن بازه",
  "shifts.range.from": "شروع",
  "shifts.range.to": "پایان",
  "shifts.range.invalid": "تاریخ پایان قبل از تاریخ شروع است",
  "shifts.range.added": "افزوده: {added}، رد شده: {skipped}",
  "shifts.deactivated": "غیرفعال",
  "shifts.more_hidden": "…و {n} شیفت دیگر (پنهان)",

  // ---------- People & stations ----------
  "people.title": "👥 افراد و ایستگاه‌ها",
  "people.stations": "🏭 ایستگاه‌ها ({n})",
  "people.add_station": "➕ افزودن ایستگاه",
  "people.station.name": "نام",
  "people.station.city": "شهر",
  "people.station.tz": "منطقه زمانی (Europe/Kyiv)",
  "people.station.new_title": "ایستگاه جدید",
  "people.station.name_placeholder": "نام (مثلاً Energo-2)",
  "people.station.confirm_delete": "ایستگاه «{name}» حذف شود؟",
  "people.station.fill_required": "نام و شهر را پر کنید",
  "people.invite.title": "دعوت جدید",
  "people.invite.placeholder": "نام کامل اپراتور",
  "people.invite.create": "➕ ایجاد دعوت",
  "people.invite.created_for": "✅ دعوت برای «{name}»",
  "people.invite.copy_failed": "کپی نشد. لینک را دستی انتخاب کنید.",
  "people.list_title": "اپراتورهای مسئول ({n})",
  "people.list_empty": "هنوز کسی نیست. یک دعوت ایجاد کنید.",
  "people.deactivate": "غیرفعال‌سازی",
  "people.activate": "فعال‌سازی",
  "people.station_label": "ایستگاه:",
  "people.station_none": "— بدون ایستگاه —",

  // ---------- Settings ----------
  "settings.title": "⚙ تنظیمات",
  "settings.notification_interval": "فاصله اعلان‌ها، دقیقه ({min}–{max})",
  "settings.notification_hint": "هر {n} دقیقه اپراتورها یک اعلان تلگرام دریافت می‌کنند. از تیک بعدی اعمال می‌شود.",
  "settings.range_error": "مقدار مجاز: {min}–{max}",
  "settings.language": "زبان",
  "settings.trigger_running": "در حال اجرا…",
  "settings.trigger_label": "⚡ تریگر: اجرای تیک ساعت",
  "settings.trigger_success": "✅ تیک اجرا شد. اپراتورهای در شیفت اعلان دریافت می‌کنند.",
  "settings.trigger_failed": "⚠ {error}",

  // ---------- Report (responsible landing) ----------
  "report.title": "📝 گزارش",
  "report.ready_to_fill": "آماده ثبت است. دکمه زیر را بزنید.",
  "report.no_slot": "⏳ ارسال ممکن نیست",
  "report.no_slot_hint": "توربین متوقف است یا شما در حال تعطیلی هستید.",
  "report.day_off": "🌴 امروز روز تعطیل شماست",
  "report.day_off_hint": "اعلان‌ها تا پایان شیفت متوقف است.",
  "report.fill_btn": "تکمیل گزارش",
  "report.fill_btn_offline": "تکمیل (توربین متوقف)",
  "report.fill_sub_active": "مقادیر برنامه برای ساعت جاری",
  "report.fill_sub_disabled": "در حال حاضر در دسترس نیست",
  "report.fill_sub_day_off": "غیرقابل‌دسترس — تعطیل",
  "report.fill_sub_offline": "ورودی به‌رنگ نارنجی علامت‌گذاری می‌شود",
  "report.emergency_btn": "وضعیت اضطراری",
  "report.emergency_sub": "ثبت اضطراری: KW + KV",
  "report.day_off_btn_off": "تعطیل",
  "report.day_off_btn_on": "لغو تعطیل",
  "report.day_off_sub_off": "علامت‌گذاری امروز به‌عنوان روز غیرکاری",
  "report.day_off_sub_on": "ازسرگیری اعلان‌های شیفت",
  "report.day_off_confirm_on": "امروز را تعطیل کنیم؟ دیگر اعلانی برای این شیفت دریافت نمی‌کنید.",
  "report.day_off_confirm_off": "لغو علامت «تعطیل» — اعلان‌ها از سر گرفته شوند؟",

  // ---------- Report form ----------
  "report_form.title": "📋 گزارش برنامه‌ای",
  "report_form.slot_label": "اسلات",
  "report_form.placeholder_pair": "X یا X/Y",
  "report_form.placeholder_single": "—",
  "report_form.filled_count": "{n} از {total} پر شده. ارسال جزئی هم مجاز است.",
  "report_form.expand_all": "باز کردن همه",
  "report_form.collapse_all": "بستن همه",
  "bool.on": "روشن",
  "bool.off": "خاموش",
  "report_form.submit": "ارسال",
  "report_form.submit_sub": "ذخیره مقادیر واردشده",
  "report_form.submitting": "در حال ارسال…",
  "report_form.cancel": "لغو",
  "report_form.cancel_sub": "مقادیر ذخیره نمی‌شوند",
  "report_form.already_completed": "این اسلات قبلاً تکمیل شده است.",
  "report_form.no_slot": "اسلات بازی نیست.",
  "report_form.offline_title": "توربین متوقف است",
  "report_form.offline_hint": "ورودی ذخیره می‌شود اما به‌رنگ نارنجی علامت‌گذاری می‌شود تا مشخص باشد در حالت توقف توربین ثبت شده است.",

  // ---------- Emergency form ----------
  "emergency.title": "🚨 وضعیت اضطراری",
  "emergency.intro": "ثبت اضطراری. KW و علت الزامی‌اند؛ سایر شاخص‌ها اختیاری هستند. پس از ارسال مدیران مطلع می‌شوند.",
  "emergency.reason_label": "علت",
  "emergency.reason_placeholder": "شرح دهید چه اتفاقی افتاد",
  "emergency.reason_required": "فیلد الزامی",
  "emergency.submit_sub_ok": "ذخیره و اطلاع مدیران",
  "emergency.submit_sub_disabled": "ابتدا علت را وارد کنید",
  "emergency.show_extras": "تکمیل سایر فیلدها (اختیاری)",
  "emergency.hide_extras": "پنهان کردن سایر فیلدها",
  "emergency.landing_what": "«وضعیت اضطراری» چیست؟",
  "emergency.landing_when": "این فقط برای رویدادهای واقعاً غیرعادی است — خرابی، نوسان، نشتی و غیره.",
  "emergency.landing_warn": "اگر فقط می‌خواهید مقادیر معمول را ثبت کنید — این برگه را ببندید و از «📝 گزارش» استفاده کنید.",
  "emergency.landing_btn": "ایجاد ثبت اضطراری",
  // ---------- Files tab ----------
  "tabs.files": "فایل‌ها",
  "files.title": "فایل‌های اخیر",
  "files.hint": "روی فایل بزنید — «تله‌متری» دقیقاً روی بازه همان فایل باز می‌شود.",
  "files.open": "باز کردن تحلیل",
  "files.rows": "ردیف",
  "files.uploaded": "بارگذاری",
  "files.all_title": "همه فایل‌های بارگذاری‌شده",
  "files.f_all": "همه",
  "files.new_rows": "ردیف‌های جدید: {n}",
  "files.repeat": "تکراری — همه از قبل ذخیره شده بود",
  "files.none": "هنوز فایلی بارگذاری نشده است.",
  "files.row_hint": "روی ردیف بزنید تا در «تله‌متری» باز شود.",
  "auto.tf_file": "فایل",

  // ---------- Период и отчёт PDF (Автоматика v2) ----------
  "tabs.telemetry": "تله‌متری",
  "telemetry.src_pa": "کنتور",
  "period.decimal": ",",
  "period.title": "بازه",
  "period.quick": "سریع",
  "period.by_file": "بر اساس فایل",
  "period.custom": "بازه دلخواه — تا ثانیه",
  "period.from": "از",
  "period.to": "تا",
  "period.duration": "مدت",
  "period.apply": "اعمال",
  "period.bad": "پایان قبل از شروع است",
  "period.change": "تغییر بازه",
  "period.file": "فایل",
  "period.tables": "جدول‌ها",
  "period.coverage": "داده‌های {s}",
  "period.s": "ث",
  "period.h": "س",
  "period.q_all": "همه داده‌ها",
  "period.q_7d": "۷ روز",
  "period.q_3d": "۳ روز",
  "period.q_24h": "۲۴ ساعت",
  "period.q_12h": "۱۲ ساعت",
  "period.q_6h": "۶ ساعت",
  "period.q_1h": "۱ ساعت",
  "period.q_lastday": "آخرین روز دارای داده",
  "period.dur_s": "{n} ث",
  "period.dur_min": "{n} دق",
  "period.dur_h": "{n} س",
  "period.dur_d": "{n} روز",
  "period.step_sec": "ثانیه‌ای",
  "period.step_min": "دقیقه‌ای",
  "period.step_5min": "هر ۵ دقیقه",
  "period.step_15min": "هر ۱۵ دقیقه",
  "period.step_hour": "ساعتی",
  "period.step_6h": "هر ۶ ساعت",
  "period.step_day": "روزانه",
  "report.pdf_title": "گزارش PDF",
  "report.includes": "محتوا",
  "report.metrics": "شاخص",
  "report.i1": "ارقام کلیدی بازه، انرژی راکتیو: تحویل‌شده / جذب‌شده",
  "report.i2": "نمودارها: ولتاژ، جریان، P، Q، فرکانس، cos φ، توزیع‌کننده، یاتاقان‌ها و واحد روغن",
  "report.i3": "جدول‌ها: توزیع‌کننده ← ولتاژ ← جریان ← cos φ ← P و Q ← بقیه",
  "report.i4": "همه ۴۳ شاخص: شروع، کمینه، میانگین، بیشینه، پایان",
  "report.i5": "انحراف‌ها: ولتاژ خارج از {lo}–{hi} کیلوولت، فرکانس، توقف‌ها و راه‌اندازی‌ها",
  "report.no_analysis": "فقط ارقام، نمودارها و جدول‌ها — بدون تفسیر.",
  "report.send": "ارسال به چت ربات",
  "report.full": "جدول‌های همه ۴۳ شاخص (بخش‌های ۲–۳)",
  "report.make": "ساخت PDF",
  "report.making": "در حال ساخت PDF… معمولاً ۳–۱۰ ثانیه",
  "report.done": "آماده شد",
  "report.pages": "صفحه",
  "report.rows_step": "{n} ردیف {step}",
  "report.sent": "به چت ربات ارسال شد",
  "report.not_sent": "ارسال به چت ناموفق بود: {err}",
  "report.open": "باز کردن در مرورگر",
  "report.send_now": "ارسال به تلگرام",

  // ---------- Главная / События / Отчёты / Управление (шаг 3) ----------
  "tabs.home": "خانه",
  "tabs.events": "رویدادها",
  "tabs.reports": "گزارش‌ها",
  "tabs.admin": "مدیریت",
  "home.title": "نیروگاه پرنده",
  "home.peak": "توان اوج",
  "home.energy": "تولید کل",
  "home.run": "زیر بار",
  "home.coverage": "چه داده‌هایی وجود دارد",
  "home.open_telemetry": "به تله‌متری",
  "home.last_data": "آخرین داده‌ها",
  "home.alarms": "هشدارها",
  "home.unit_day": "کار {run} · بیشینه {kw} کیلووات",
  "home.events": "آخرین رویدادها",
  "home.all": "همه",
  "home.no_events": "توقف یا افت ولتاژی در داده‌ها نیست.",
  "home.ev_trip": "قطع G{u} زیر بار {kw} کیلووات",
  "home.ev_stop": "توقف G{u} ({kw} کیلووات پیش از آن)",
  "home.ev_dip": "افت ولتاژ G{u} تا {kv} کیلوولت، {s} ث",
  "home.ev_below": "زیر ۱۸ کیلوولت {s} ث",
  "home.events_hint": "از تله‌متری: توقف‌ها (توان → ۰) و افت‌های ولتاژ زیر {kv} کیلوولت زیر بار. بزنید تا تله‌متری ±۴۵ ثانیه باز شود.",
  "home.reports": "گزارش‌های اخیر",
  "events.sub_incidents": "بررسی‌ها",
  "events.sub_spikes": "جهش‌ها",
  "reports.current": "انتخاب‌شده در تله‌متری",
  "reports.new_pdf": "PDF جدید برای بازه",
  "reports.generated": "PDFهای ساخته‌شده",
  "reports.none": "هنوز هیچ — «PDF جدید برای بازه» را بزنید.",
  "reports.made": "ساخته شد",
  "reports.sent": "به چت ارسال شد",
  "reports.excel": "اکسل برای بازه انتخاب‌شده",
  "admin.sub_data": "داده‌ها",

  // ---------- События: лента и карточка (шаг 4) ----------
  "events.sub_feed": "فید",
  "events.k_all": "همه",
  "events.k_trip": "قطع‌ها",
  "events.k_dip": "افت‌های ولتاژ",
  "events.k_stops": "توقف و راه‌اندازی",
  "events.k_alarm": "هشدارها",
  "events.k_case": "بررسی‌ها",
  "events.u_all": "همه",
  "events.none": "رویدادی با این شرایط نیست.",
  "ev.trip": "قطع G{u} زیر بار {kw} کیلووات",
  "ev.stop": "توقف G{u} ({kw} کیلووات پیش از آن)",
  "ev.start": "راه‌اندازی G{u}",
  "ev.start_sub": "یک دقیقه بعد {kw} کیلووات",
  "ev.dip": "افت ولتاژ G{u} تا {kv} کیلوولت، {s} ث",
  "ev.below": "زیر {kv} کیلوولت {s} ث",
  "ev.active": "فعال",
  "ev.acked": "تأیید‌شده",
  "ev.case": "بررسی: قطع {u}، {d} {h}",
  "ev.case_sub": "جدول ثانیه‌ای و هشدارها",
  "ev.chart_u": "ولتاژ RS / ST / RT، کیلوولت (±۶۰ ث)",
  "ev.chart_p": "توان اکتیو، کیلووات",
  "ev.no_telemetry": "تله‌متری برای این لحظه نیست.",
  "ev.alarms_around": "هشدارها ±۵ دقیقه",
  "ev.open_case": "باز کردن بررسی",
  "ev.open_telemetry": "باز کردن در تله‌متری",

  // ---------- Управление: Нормы и Система (шаг 5) ----------
  "admin.sub_norms": "معیارها",
  "admin.sub_system": "سیستم",
  "norms.intro": "آستانه‌هایی که برنامه با آن‌ها رویدادها را پیدا و انحراف‌ها را مشخص می‌کند. هر تنظیم در همه بخش‌ها و در گزارش PDF اعمال می‌شود.",
  "norms.g_voltage": "ولتاژ ۲۰ کیلوولت",
  "norms.g_trips": "قطع‌ها",
  "norms.g_freq": "فرکانس",
  "norms.g_spikes": "جهش‌های ولتاژ",
  "norms.g_history": "تاریخچه تغییرات",
  "norms.v_band": "کریدور ولتاژ",
  "norms.v_dip": "افت ولتاژ",
  "norms.trip_s": "قطع یا توقف",
  "norms.f_band": "محدوده فرکانس",
  "norms.sharp_kv": "جهش ناگهانی",
  "norms.prolonged_s": "خروج طولانی از کریدور",
  "norms.v_band_val": "{lo}–{hi} kV",
  "norms.v_dip_val": "زیر {v} kV",
  "norms.trip_s_val": "سریع‌تر از {v} ث",
  "norms.f_band_val": "{lo}–{hi} Hz",
  "norms.sharp_kv_val": "از {v} kV در ۱ ث",
  "norms.prolonged_s_val": "از {v} ث",
  "norms.v_band_sub": "خارج از کریدور زیر بار: G1 — {g1}٪ دقایق، G2 — {g2}٪",
  "norms.v_dip_sub": "{pct}٪ از ۲۰ کیلوولت، زیر بار، بیش از ۲ ثانیه · افت‌های فعلی: {n}",
  "norms.trip_s_sub": "بار سریع‌تر به صفر رسید — قطع، کندتر — توقف برنامه‌ریزی‌شده · اکنون {trips} قطع و {stops} توقف",
  "norms.f_band_sub": "خارج از محدوده زیر بار: G1 — {g1} دقیقه، G2 — {g2} دقیقه",
  "norms.sharp_kv_sub": "جهش ولتاژ بین دو ثانیه پیاپی",
  "norms.prolonged_s_sub": "ولتاژ بدون وقفه خارج از کریدور",
  "norms.w_band": "کریدور",
  "norms.w_feed": "فهرست رویدادها",
  "norms.w_pdf": "PDF",
  "norms.changed": "تغییر کرده",
  "norms.default_is": "پیش‌فرض {v}",
  "norms.history_empty": "هنوز هیچ معیاری تغییر نکرده — مقادیر پیش‌فرض اعمال می‌شوند.",
  "norms.revert": "بازگرداندن",
  "norms.footer": "پس از ذخیره یک معیار، رویدادها در حدود یک ثانیه دوباره محاسبه می‌شوند. PDFهای ساخته‌شده تغییر نمی‌کنند: در هر کدام معیارهایی که با آن ساخته شده ذکر شده است.",
  "norms.saved": "ذخیره شد",
  "norms.saved_rebuilt": "ذخیره شد، رویدادها دوباره محاسبه شدند",
  "norms.undo": "بازگشت به قبل",
  "norms.done_dips": "افت‌ها اکنون: {n}.",
  "norms.done_trips": "اکنون {trips} قطع و {stops} توقف.",
  "norms.threshold": "آستانه",
  "norms.lower": "حد پایین",
  "norms.upper": "حد بالا",
  "norms.u_kv": "kV",
  "norms.u_s": "ث",
  "norms.u_hz": "Hz",
  "norms.pct_nominal": "{p}٪ از ۲۰ کیلوولت",
  "norms.bad_range": "حد پایین باید کمتر از حد بالا باشد.",
  "norms.now": "اکنون",
  "norms.if_saved": "در صورت ذخیره",
  "norms.counting": "در حال محاسبه…",
  "norms.counting_slow": "محاسبه روی همه ثانیه‌ها، تا ۱۰ ثانیه…",
  "norms.computed_on": "روی همه داده‌های G1 و G2 محاسبه شده است.",
  "norms.save": "ذخیره",
  "norms.save_rebuild": "ذخیره و محاسبه دوباره رویدادها",
  "norms.saving": "در حال ذخیره…",
  "norms.unchanged": "بدون تغییر",
  "norms.reset": "بازگشت به پیش‌فرض: {v}",
  "norms.pv_dips": "افت‌ها",
  "norms.pv_trips": "قطع‌ها",
  "norms.pv_stops": "توقف‌ها",
  "norms.pv_band": "خارج از کریدور، ٪ دقایق زیر بار",
  "norms.pv_freq": "خارج از محدوده، دقایق زیر بار",
  "norms.pv_sharp": "ثانیه‌های جهش",
  "norms.pv_prolonged": "خروج‌های طولانی",
  "norms.v_band_desc": "ولتاژ خط زیر بار باید داخل کریدور بماند. دقایقی که حتی یک فاز از آن خارج شود در تله‌متری، کریدور، جهش‌ها، بررسی‌ها و PDF علامت‌گذاری می‌شوند.",
  "norms.v_dip_desc": "ولتاژ خط زیر آستانه، زیر بار و بیش از ۲ ثانیه. افت‌هایی که کمتر از ۲ دقیقه فاصله دارند یکی حساب می‌شوند.",
  "norms.trip_s_desc": "اگر بار سریع‌تر از این به صفر برسد قطع است (کلید قطع شده)؛ کندتر — توقف برنامه‌ریزی‌شده (بسته شدن پره‌های هادی).",
  "norms.f_band_desc": "فرکانس زیر بار؛ خروج از محدوده در بخش «انحراف‌ها»ی گزارش PDF شمرده می‌شود.",
  "norms.sharp_kv_desc": "جهش ولتاژ خط بین دو ثانیه پیاپی که از آن به بعد آن ثانیه ناگهانی شمرده می‌شود (بخش جهش‌ها).",
  "norms.prolonged_s_desc": "چند ثانیه پیاپی ولتاژ (فاز ST) باید خارج از کریدور باشد تا خروج طولانی شمرده شود (بخش جهش‌ها).",
  "norms.v_band_std": "یعنی ۲۰ کیلوولت ± ۵٪.",
  "norms.v_dip_std": "یعنی ۹۰٪ مقدار نامی — تعریف افت در GOST 32144 / EN 50160.",
  "system.at": "وضعیت در {t}، به وقت نیروگاه",
  "system.refresh": "به‌روزرسانی",
  "system.services": "سرویس‌ها",
  "system.svc_bot": "ربات @{bot}",
  "system.svc_api": "برنامه (API)",
  "system.svc_db": "پایگاه داده",
  "system.svc_web": "وب‌سایت و HTTPS",
  "system.running": "فعال",
  "system.down": "غیرفعال",
  "system.since": "از {t}",
  "system.cert": "گواهی تا {d}، خودکار تمدید می‌شود",
  "system.restart_hint": "به وقت نیروگاه. اگر پایگاه داده و وب‌سایت شب با هم دوباره راه‌اندازی شده‌اند، به‌روزرسانی امنیتی خودکار سرور بوده، نه خرابی.",
  "system.server": "سرور",
  "system.disk": "دیسک",
  "system.mem": "حافظه",
  "system.load": "بار پردازنده",
  "system.cores": "{n} هسته",
  "system.uptime": "از آخرین راه‌اندازی",
  "system.uptime_v": "{d} روز {h} ساعت",
  "system.of": "{a} از {b}",
  "system.db": "پایگاه داده · {size}",
  "system.g_v2_sec": "تله‌متری G1/G2، ثانیه‌ای",
  "system.g_v2_min": "تله‌متری G1/G2، دقیقه‌ای",
  "system.g_old": "جدول‌های قدیمی SCADA",
  "system.g_old_sub": "به G1 منتقل شده‌اند، برنامه آن‌ها را نمی‌خواند",
  "system.g_pa": "کنتور (Power Analyzer)",
  "system.g_other": "هشدارها، رویدادها، کاربران، گزارش‌ها",
  "system.rows": "≈{n} ردیف",
  "system.rows_m": "≈{n} میلیون ردیف",
  "system.last_import": "آخرین فایل — {f}، داده تا {to}.",
  "system.analyzed": "آمار پرس‌وجو در {t} به‌روز شد.",
  "system.backups": "پشتیبان‌ها",
  "system.no_backup": "پشتیبانی وجود ندارد",
  "system.timer_off": "پشتیبان شبانه خاموش است",
  "system.last_failed": "آخرین پشتیبان ناموفق بود — جزئیات در گزارش سرور",
  "system.last_ok": "آخرین پشتیبان موفق — {t}، {size}",
  "system.k_db": "کل پایگاه داده",
  "system.k_full_set": "مجموعه کامل: پایگاه داده، کد، تنظیمات",
  "system.k_v2_tables_step": "جدول‌های G1/G2 پیش از مرحله ۲",
  "system.k_v2_tables_import": "جدول‌های G1/G2 پیش از بارگذاری فایل",
  "system.k_v1_tables": "جدول‌های قدیمی SCADA پیش از حذف",
  "system.k_other": "پشتیبان دیگر",
  "system.nightly": "پشتیبان شبانه",
  "system.nightly_on": "ساعت ۰۳:۰۰ به وقت نیروگاه، ۱۴ روز نگهداری · بعدی {t}",
  "system.nightly_off": "خاموش — روشن کنید تا پایگاه داده هر شب ذخیره شود",
  "system.free": "{v} آزاد",
  "system.backup_now": "پشتیبان‌گیری اکنون",
  "system.backup_running": "در حال پشتیبان‌گیری… حدود یک دقیقه",
  "system.backup_done": "پشتیبان آماده شد: {size}",
  "system.backup_failed": "پشتیبان‌گیری ناموفق بود — جزئیات در گزارش سرور",
  "system.reports": "گزارش‌ها و رویدادها",
  "system.pdf": "گزارش‌های PDF",
  "system.pdf_sub": "{n} ساخته شده · فایل‌های قدیمی‌تر از {d} روز حذف می‌شوند",
  "system.events": "رویدادها",
  "system.events_sub": "قطع‌ها، توقف‌ها، راه‌اندازی‌ها، افت‌ها · محاسبه در {t}",
  "system.rebuild": "محاسبه دوباره رویدادها",
  "system.rebuilt": "محاسبه شد: {n} رویداد",
  "u.mb": "MB",
  "u.gb": "GB",
  // ---------- 03.10.2026: reactive energy, chart sets, PDF row step and events ----------
  "auto.kpi_react": "انرژی راکتیو",
  "auto.react_out": "تحویل به شبکه · Q > 0",
  "auto.react_in": "جذب‌شده · Q < 0",
  "auto.react_hint": "Q > 0 — ژنراتور توان راکتیو را به شبکه می‌دهد، Q < 0 — از شبکه جذب می‌کند.",
  "auto.kvarh": "کیلووار‌ساعت",
  "auto.mvarh": "مگاوار‌ساعت",
  "home.react": "راکتیو: تحویل {out} · جذب {inn} {u}",
  "charts.set": "مجموعه",
  "charts.set_one": "یک شاخص",
  "charts.set_bearings": "یاتاقان‌ها",
  "charts.set_oil": "واحد روغن",
  "charts.set_windings": "سیم‌پیچ‌ها",
  "charts.set_hydraulics": "سیستم هیدرولیک",
  "charts.set_hint": "خاکستری — ژنراتور متوقف بود. دما و فشار روغن در زمان توقف هم نشان داده می‌شوند.",
  "charts.set_under_load": "زیر بار",
  "report.step": "گام ردیف‌های جدول",
  "report.step_auto": "خودکار",
  "report.step_hint": "خودکار — مثل قبل: حداکثر ۱۲۰ ردیف. هر گامی مجاز است اگر ردیف‌ها بیش از ۳۶۰۰ نباشند (ثانیه‌ای — تا ۱ ساعت).",
  "report.step_off": "کم‌رنگ — بیش از ۳۶۰۰ ردیف: بازه را کوتاه کنید. داده ثانیه‌ای برای بازه طولانی — Excel در «گزارش‌ها» (مدیر).",
  "report.rows_n": "{n} ردیف",
  "report.many": "صفحات زیاد است. بدون بخش‌های ۲–۳ حدود {n} صفحه می‌شود.",
  "report.events": "راه‌اندازی‌ها و قطع‌ها",
  "report.ev_counts": "در بازه: قطع اضطراری — {trip}، توقف — {stop}، راه‌اندازی — {start}، افت ولتاژ — {dip}",
  "report.ev_none": "در بازه رویدادی نیست",
  "report.i6": "رویدادها: راه‌اندازی، قطع اضطراری، توقف، افت ولتاژ — با آلارم‌های نزدیک",
  "report.making_big": "در حال ساخت PDF بزرگ… تا ۲–۳ دقیقه",
  "period.step_10s": "هر ۱۰ ثانیه",
  // ---------- 03.10.2026, step 2: uploads with a preview ----------
  "up.title": "بارگذاری داده",
  "up.hint": "گزارش ایستگاه G1/G2 (.csv، .gz)، فایل کنتور (.xlsx)، دفتر آلارم (.csv) یا آرشیو .zip از این فایل‌ها. اول نشان می‌دهم چه چیزی داخل آن است و چه چیزی از قبل ذخیره شده — تا دکمه را نزنید چیزی نوشته نمی‌شود.",
  "up.reading": "در حال خواندن فایل… آرشیو بزرگ تا یک دقیقه",
  "up.items": "محتوای فایل",
  "up.kind_nounit": "G1 یا G2؟",
  "up.kind_meter": "کنتور",
  "up.kind_alarms": "دفتر آلارم",
  "up.kind_unknown": "شناخته نشد",
  "up.rows": "{n} ردیف",
  "up.alarm_rows": "{n} مورد",
  "up.new": "جدید: {n}",
  "up.in_db": "از قبل ذخیره شده: {n}",
  "up.clock_moved": "زمان فایل (خروجی «;») به وقت ایستگاه تبدیل شد: {shift}",
  "up.clock_as_is": "زمان فایل از قبل به وقت ایستگاه است — جابه‌جا نشد",
  "up.clock_check": "در مقایسه با دفتر ذخیره‌شده: با جابه‌جایی {a} مطابقت، بدون آن {b}",
  "up.clock_by_journal": "مانند دفتر آلارم همین بارگذاری",
  "up.pick_unit": "کدام ژنراتور؟",
  "up.more_days": "و {n} روز دیگر",
  "up.legend_new": "جدید",
  "up.legend_part": "بخشی ذخیره شده",
  "up.legend_db": "از قبل ذخیره شده",
  "up.legend_none": "در فایل نیست",
  "up.how": "نحوه بارگذاری",
  "up.mode_missing": "فقط موارد ناموجود",
  "up.mode_missing_sub": "آنچه از قبل ذخیره شده دست نمی‌خورد",
  "up.mode_replace": "جایگزینی بازه",
  "up.mode_replace_sub": "در محدوده فایل، داده‌های ذخیره‌شده بازه حذف و از فایل گرفته می‌شوند",
  "up.range": "بازه بارگذاری — به‌طور پیش‌فرض کل فایل، تا یک ثانیه قابل محدود کردن",
  "up.need_unit": "برای فایل‌هایی که G1/G2 در نامشان نیست ژنراتور را انتخاب کنید — وگرنه رد می‌شوند.",
  "up.nothing": "همه محتوای فایل از قبل ذخیره شده — چیزی برای بارگذاری نیست.",
  "up.go": "بارگذاری",
  "up.go_new": "بارگذاری داده جدید: {n} ردیف",
  "up.running": "در حال بارگذاری… می‌توانید صفحه را ببندید — روی سرور انجام می‌شود",
  "up.done": "انجام شد",
  "up.again": "بارگذاری فایل دیگر",
  "up.st_running": "در حال بارگذاری",
  "up.st_done": "{n} ردیف بارگذاری شد",
  "up.st_events": "رویدادهای یافته‌شده: {n}",
  "up.st_nothing": "همه از قبل ذخیره شده بود",
  "up.st_error": "خطا",
  "up.st_skip": "رد شد",
  "up.st_ready": "در صف",
  "up.alarms_title": "دفتر آلارم ایستگاه",
  "up.alarms_cover": "{n} مورد ذخیره شده: {from} ← {to}",
  "up.src_alarms": "دفتر آلارم",
  "up.src_hint": "این انتخاب ژنراتور را برای گزارش‌های بدون G1/G2 در نام و تاریخچه زیر تعیین می‌کند؛ در آرشیو می‌توان هر فایلی را ترکیب کرد.",
  // ---------- 03.10.2026, step 3: the bot takes files ----------
  "users.right_upload": "بارگذاری داده از طریق ربات",
};
